import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { BaseDialogComponent } from '@cumlaude/shared-components-dialogs';
import { FavorietenListComponent } from '../../../favorieten-list/favorieten-list.component';

@Component({
	selector: 'app-favorieten-dialog',
	templateUrl: './favorieten-dialog.component.html',
	imports: [BaseDialogComponent, FavorietenListComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavorietenDialogComponent {
	private readonly dialogRef = inject(DialogRef);

	sluiten() {
		this.dialogRef.close();
	}
}
